import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { insertSet } from '../../actions/project/set'
import CollectionProductsSet from '../../components/CollectionProductsSets'
import { assignIndex } from '../../utils'

const mapStateToProps = state => ({
  photos: dotProp.get(state, 'products.sets', []).map(assignIndex),
  isLoading: dotProp.get(state, 'products.isLoading', false),
  errMessage: dotProp.get(state, 'products.errMessage', ''),
})

const mapDispatchToProps = dispatch => ({
  insert: index => dispatch(insertSet(index)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionProductsSet)



// WEBPACK FOOTER //
// ./src/containers/CollectionProductsSets/index.js